<template>
  <div class="wrap">
    <!-- 상단 해더 -->
    <div class="header">
      <div class="store_name">{{ info ? info.name : "매장 접속중" }}</div>
      <div class="time">
        <clock></clock>
      </div>
    </div>

    <!-- 입장안내, 대기 목록 -->
    <div class="top_area">
      <div class="entrance_area">
        <div class="entrance_title">
          <div style="margin-left: 32px;">입장 안내</div>
          <div class="bold_nomal" style="margin-right: 32px;">{{ info.useWaitingConfirmCode ? `대기확정코드 ${otpNumber}` : '대기확정 코드 미사용 매장' }}</div>
        </div>
        <ul class="entrance_list">
          <li v-for="i in 8" :key="i">
            <div
              class="entrance_item"
              v-if="notificationList[i-1]"
              :class="!notificationList[i-1].guest.phone ? 'noPhone' : ''"
            >
              <span class="entrance_num">{{ notificationList[i-1].waitSequenceStatic }}</span>
              <br v-if="notificationList[i-1].guest.phone" />
              <span
                class="entrance_phone"
                v-if="notificationList[i-1].guest.phone"
              >{{ notificationList[i-1].guest.phone.slice(-4) }}</span>
              <div
                class="active_line"
                :class="enterItem && enterItem.idx === notificationList[i-1].idx ? 'active' : ''"
              ></div>
            </div>
          </li>
        </ul>
      </div>
      <div class="waiting_area">
        <div class="waiting_title">대기 목록</div>
        <ul class="waiting_list">
          <li v-for="i in 4" :key="i">
            <div class="waiting_num" v-if="list[i-1]">
              {{ list[i-1].waitSequenceStatic }}
              <span>번</span>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <!-- 광고영역 -->
    <div class="ad_area">
      <video
        v-show="adList[adIndex].type === 'video'"
        id="video"
        autoplay
        poster="/images/vertical_bg/1017x1356_loding.png"
      >
        <source :src="adList[adIndex].verticalUrl || adList[adIndex].url" type="video/mp4" />
      </video>
      <div v-show="adList[adIndex].type && adList[adIndex].type === 'image'" style="width:100%;">
        <img
          :src="adList[adIndex].verticalUrl || adList[adIndex].url"
          style="width:100%; height:100%; object-fit: cover;"
        />
      </div>
    </div>

    <!-- 하단 풋터 -->
    <div class="footer">
      <div class="footer_left">
        <span class="footer_text">광고제휴문의: 1899-9195</span>
      </div>
      <div class="version_text">v{{ version }}</div>
    </div>
  </div>
</template>

<script>
import Clock from '@/components/Clock'
export default {
  props: [
    'notificationList',
    'is-playing',
    'restaurant-idx',
    'enter-item',
    'ad-index',
    'ad-list',
    'info',
    'list',
    'msg',
    'menu-list',
    'display-menu',
    'expectation-time',
    'version',
    'otpNumber'
  ],
  name: 'vertical-view',
  components: {
    Clock
  },
  computed: {
    // notificationList () {
    //   return this.list.filter(v => {
    //     return v.notificationCount >= 1
    //   })
    // },
    watingList () {
      return this.list.filter(v => {
        return v.notificationCount === 0
      })
    }
  }
}
</script>

<style lang="scss" scoped>
ul,
li {
  margin: 0;
  padding: 0;
}
li {
  list-style: none;
}

@-webkit-keyframes blink {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

.wrap {
  width: 100%;
  background: #111225;
  padding: 0 30px;
  min-width: 1080px;

  .header {
    display: flex;
    height: 60px;
    line-height: 60px;
    font-size: 28px;
    color: #fff;
    justify-content: space-between;
  }

  .top_area {
    display: flex;
    margin-bottom: 20px;

    .entrance_area {
      width: 741px;
      height: 432px;
      // background: #fff;
      margin-right: 20px;
      border-radius: 8px;
      .entrance_title {
        position: relative;
        height: 100px;
        line-height: 100px;
        font-size: 45px;
        font-weight: bold;
        color: #fff;
        // background: linear-gradient(-300deg, #ffe86a -50%, #ff4c32 100%);
        background: #ff4c32;
        border-radius: 8px 8px 0 0;
        display: flex;
        justify-content: space-between;
        .bold_nomal {
          font-size: 36px;
          font-weight: normal;
        }
        &:after {
          content: "";
          display: block;
          position: absolute;
          width: 100%;
          height: 5px;
          background: linear-gradient(to bottom, #0000004c, #00000000);
        }
      }
      .entrance_list {
        display: flex;
        flex-wrap: wrap;
        overflow: hidden;
        border-radius: 0 0 8px 8px;
        li {
          width: 185px;
          height: 166px;
          box-sizing: border-box;

          &:nth-child(1),
          &:nth-child(3),
          &:nth-child(6),
          &:nth-child(8) {
            background: #ebebeb;
          }
          &:nth-child(2),
          &:nth-child(4),
          &:nth-child(5),
          &:nth-child(7) {
            background: #d8d8d8;
          }

          .entrance_item {
            position: relative;
            width: 100%;
            height: 100%;
            box-sizing: border-box;
            .active_line {
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              &.active {
                border: 6px solid #f85a40;
                animation: blink forwards 2s 4;
              }
            }
            .entrance_num {
              display: inline-block;
              padding-top: 25px;
              font-size: 60px;
              font-weight: bold;
              color: #f85a40;
            }
            .entrance_phone {
              font-size: 35px;
              color: rgba(0, 0, 0, 0.6);
            }

            &.noPhone {
              display: flex;
              align-items: center;
              justify-content: center;
              height: 100%;
              .entrance_num {
                padding-top: 0;
                font-size: 80px;
                font-weight: bold;
                color: #f85a40;
              }
            }
          }
        }
      }
    }
    .waiting_area {
      width: 256px;
      height: 432px;
      // background: #fff;
      border-radius: 8px;
      .waiting_title {
        position: relative;
        height: 100px;
        line-height: 100px;
        font-size: 45px;
        font-weight: bold;
        color: #000;
        background: #fff;
        border-radius: 8px 8px 0 0;
        &:after {
          content: "";
          display: block;
          position: absolute;
          width: 100%;
          height: 5px;
          background: linear-gradient(to bottom, #0000004c, #00000000);
        }
      }
      .waiting_list {
        overflow: hidden;
        border-radius: 0 0 8px 8px;
        li {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 83px;
          border-bottom: 1px solid #979797;
          box-sizing: border-box;
          &:nth-child(odd) {
            background: #d8d8d8;
          }
          &:nth-child(even) {
            background: #ebebeb;
          }
          &:last-child {
            border-bottom: 0;
          }
          .waiting_num {
            font-size: 45px;
            font-weight: bold;
            color: #000;
            span {
              position: relative;
              top: -5px;
              font-size: 30px;
              font-weight: 400;
            }
          }
        }
      }
    }
  }

  // 광고영역
  .ad_area {
    width: 1017px;
    height: 1356px;
    // background: #fff;
    display: flex;
    align-items: center;
    video {
      width: 100%;
    }
  }

  // 하단 텍스트
  .footer {
    display: flex;
    height: 52px;
    line-height: 52px;
    font-size: 21px;
    color: #fff;
    justify-content: space-between;

    .footer_left {
      display: flex;
      align-items: center;
    }
  }
}
</style>
